<template>
  <div class="fetch__error"><span style="    background-color: rgba(211, 255, 198, 0.4); color: rgb(84, 183, 3); border: 1px solid rgba(84, 183, 3, 0.2);">420, Enhance Your Calm (work in progress)</span></div>
</template>